import { render } from "./BankInfo.vue?vue&type=template&id=09a864a0&scoped=true"
import script from "./BankInfo.vue?vue&type=script&lang=js"
export * from "./BankInfo.vue?vue&type=script&lang=js"

import "./BankInfo.vue?vue&type=style&index=0&id=09a864a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a864a0"]])

export default __exports__